import Service from 'src/setup/network';
import { Dispatch } from 'redux';
import {
  FETCH_SETTING_FAILURE,
  FETCH_SETTING_REQUEST,
  FETCH_SETTING_SUCCESS,
  SettingActionType,
} from '../types/settingType';
import jsPDF from 'jspdf';

export const fetchSettingRequest = (): SettingActionType => ({
  type: FETCH_SETTING_REQUEST,
});

export const fetchSettingSuccess = (data: any): SettingActionType => ({
  type: FETCH_SETTING_SUCCESS,
  payload: data,
});

export const fetchSettingFailure = (error: string): SettingActionType => ({
  type: FETCH_SETTING_FAILURE,
  payload: error,
});

export const fetchSetting = () => {
  return async (dispatch: Dispatch<SettingActionType>) => {
    dispatch(fetchSettingRequest());
    try {
      const response = await Service.get('/settings');
      const data = await response?.data;
      dispatch(fetchSettingSuccess(data));
    } catch (error: any) {
      dispatch(fetchSettingFailure(error));
      throw new Error('Failed to fetch setting data');
    }
  };
};
